import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
};

export const ITEMS_LIST = 'GET_EMPLOYEE_LIST';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "id": "empl.id",
                "name": "empl.name",
                "birthday": "empl.birthday",
                "sex": "empl.sex",
                "works_since": "empl.works_since",
                "department_name": "dep.name",
                "position_name": "pos.name",
                "fired_at": "empl.fired_at"
            };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["empl.name", {"$": `%${query.name}%`}] })
            }

            if (query.department_name) {
                filter.push({ "$ilike": ["dep.name", {"$": `%${query.department_name}%`}] })
            }

            if (query.position_name) {
                filter.push({ "$ilike": ["pos.name", {"$": `%${query.position_name}%`}] })
            }

            if (query.view == 'free') {
                filter.push({"$null": [`empl.department_id`]})
            } else {
                filter.push({"$not": [
                    { "$null": [`empl.department_id`] }
                ]})
            }
            // { "$ilike": ["empl.name", {"$": `%${$filterQ}%`}] },

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:employees",
                    "from_as": "empl",
                    "joins": [
                      {
                        "join": "s:departments",
                        "type": "left",
                        "as":   "dep",
                        "on": {
                          "$eq": ["empl.department_id", "dep.id"]
                        }
                      },
                      {
                        "join": "s:positions",
                        "type": "left",
                        "as":   "pos",
                        "on": {
                          "$eq": ["empl.position_id", "pos.id"]
                        }
                      }
                    ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'desc' ? { $desc: [columns[query.sortField || 'name' ]] } : { $asc: [columns[query.sortField || 'name']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    // loadData({ commit, getters, dispatch }) {
    //     const vm = (this as any)._vm;

    //     dispatch('loadFilterData')
    //         .then(() => {
    //             console.log('1')
    //         });
    // },

};

export const mutations: MutationTree<WorkPlanBoardState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_employee_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
